import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {DtoImportObjectContext} from "../../../../../../core/shared/dto/dto.import.object.context";
import {WidgetHelperButton} from "../../../../../../core/shared/basic/widget-helper-button";
import {MvsObjectService} from "../../../../../../core/shared/service/object/mvs-object.service";
import {ObjectIdentifier} from "../../../../../../core/shared/basic/object-identifier";
import {FilterCriteria} from "../../../../../../core/shared/filter/api/filter.criteria";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {DtoImportObjectContextEntry} from "../../../../../../core/shared/dto/dto.import.object.context.entry";
import {CustomerDto} from "../../../../../cr/model/dto/entity/customer.dto";
import {ContractDto} from "../../../../model/dto/entity/contract.dto";
import {QlQueryDto} from "../../../../../../core/shared/ql/data/dto/ql-query.dto";

// NOT_IN_USE
@Component({
    selector: 'cm-contract-person-object-widgets-consultant',
    templateUrl: './contract-person-object-widget-consultant.component.html',
    standalone: false
})
export class ContractPersonObjectWidgetConsultantComponent implements OnInit, OnChanges {

  @Input() customerDto: CustomerDto;
  @Input() contractDto: ContractDto;
  personsWidget: WidgetData;
  objectsWidget: WidgetData;
  contextContractAndCustomer: DtoImportObjectContext;
  personWidgetToolbarButtons: WidgetHelperButton[];
  initialized: boolean;
  disableUpdate: boolean = true;

  constructor(protected objectService: MvsObjectService) {
  }

  ngOnInit(): void {
    this.initComponent();
    this.initialized = true;
  }

  initComponent() {
    this.refreshComponent();
  }

  refreshComponent() {
    this.refreshWidgets();
    this.initialized = true;
  }

  refreshWidgets() {

    // create import object context
    this.contextContractAndCustomer = DtoImportObjectContext.createFromObjectIdentifiers(
      new ObjectIdentifier("cm.Contract", this.contractDto.id),
      new ObjectIdentifier("cr.Customer", this.customerDto.id)
    );

    const filterCriteria = FilterCriteria.create("e.contractId", FilterCriteria.cOperatorEqual, this.contractDto.id);

    const personQuery: QlQueryDto = {
          name: "cm.contract.objects.navigation.persons",
          type: "view",

          start: {
              name: "ci.ContractPerson",
              as: "e",
              type: "entity",
              joins: [
                  {
                      joinType: "left",
                      type: "entity",
                      name: "person",
                      as: "person",
                      joins: [
                          {
                              joinType: "left",
                              type: "entity",
                              name: "personDetail",
                              as: "personDetail"
                          }
                      ]
                  }
              ]
          },

          fixedFilters: [filterCriteria],   // external → do NOT modify
          sortings: []
      };

      this.personsWidget = WidgetFactory.createWidgetListQl(
          "cm.contract.objects.navigation.persons",
          "Personen",
          "list",
          personQuery
      );

    // this.personsWidget = WidgetFactory.createWidgetList(
    //   "cm.contract.objects.navigation.persons",
    //   "Personen",
    //   "list",
    //   "list",
    //   "entity",
    //   "ci.ContractPerson",
    //   "Keine versicherten Personen vorhanden",
    //   ObjectRequestList.createComplexRequestList(
    //     true,
    //     ObjectRequestComplex.build(
    //       true,
    //       false,
    //       ObjectRequestComplexNode.createSimpleAttributeNode(
    //         "person",
    //       ).addNodes(
    //         ObjectRequestComplexNode.createSimpleAttributeNode('personDetail')
    //       )
    //
    //     ),
    //     [filterCriteria],
    //     [],
    //     null)
    // );

    if (this.customerDto && this.customerDto.personDtoId) {
      this.personWidgetToolbarButtons = [{
        icon: 'fa-light fa-user-plus',
        label: '',
        display: true,
        action: 'assignCustomer',
        tooltip: 'Kunden hinzufügen'
      }];
    }

    // create widget to display the insurable objects
      const objectQuery: QlQueryDto = {
          name: "cm.contract.objects.navigation.objects",
          type: "view",

          start: {
              name: "ci.ContractInsurableObject",
              as: "e",
              type: "entity",
              joins: [
                  {
                      joinType: "left",
                      type: "entity",
                      name: "insurableObject",
                      as: "insurableObject"
                  }
              ]
          },

          filters: [filterCriteria],   // external → DO NOT MODIFY
          sortings: []
      };
      this.objectsWidget = WidgetFactory.createWidgetListQl(
          "cm.contract.objects.navigation.objects",
          "Objekte",
          "list",
          objectQuery
      );


      // this.objectsWidget = WidgetFactory.createWidgetList(
    //   "cm.contract.objects.navigation.objects",
    //   "Objekte",
    //   "list",
    //   "list",
    //   "entity",
    //   "ci.ContractInsurableObject",
    //   "Keine versicherten Objekte vorhanden",
    //   ObjectRequestList.createComplexRequestList(
    //     true,
    //     ObjectRequestComplex.build(true, false, ObjectRequestComplexNode.createRelationNode("insurableObject", ObjectRequestRelation.createJoin("insurableObject"))),
    //     [filterCriteria],
    //     [],
    //     null)
    // );


  }

  handlePersonWidgetToolbarClick(event: WidgetHelperButton) {

    const context = this.contextContractAndCustomer.copy();
    context.addEntry(new DtoImportObjectContextEntry("pm.Person", this.customerDto.personDtoId));

    if (event.action === 'assignCustomer') {
      // this.objectService.openObjectViaDialog(
      //     context,
      //     "ci.ContractPerson",
      //     0,
      //     null,
      //     false,
      //     false,
      //     () => {
      //         //
      //     },
      //     MvsCrudModeEnum.create
      // );
    }

  }


  /**
   * Process changes within Binding.
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {

    if (!this.initialized) {
      return;
    }

    if (changes["customerDto"] || changes["contractDto"]) {
      this.refreshComponent();
    }

  }

}
